<template>
	<Teleport to="body">
		<Transition name="fade">
			<div v-if="isActive" class="ui-modal-container">
				<!-- Контент -->
				<div
					class="ui-modal viewport-max-width"
					:style="{ maxWidth: maxWidth + 'px' }"
				>
					<slot></slot>

					<!-- Кнопка крестик -->
					<div
						v-if="showCloseButton"
						data-testid="modal-close-btn"
						class="ui-modal-close-btn"
						@click="hide"
					>
						<img src="@/assets/icons/close-icon-black.svg" alt="" />
					</div>
				</div>

				<!-- Оверлей -->
				<div class="ui-modal-overlay" @click="onOverlayClick"></div>
			</div>
		</Transition>
	</Teleport>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { application } from '@/utils/plugins/di/providers';

interface Props {
	closeable?: boolean;
	maxWidth?: string;
	showCloseButton?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	closeable: true,
	showCloseButton: false
});

const emit = defineEmits<{ (e: 'opened'): void; (e: 'closed'): void }>();

const isActive = ref(false);

/**
 * Открыть модальное окно
 */
const open = () => {
	isActive.value = true;
	application.handleNavigationToBack();
	application.whenNavigationToBack(hide);
	emit('opened');
};

/**
 * Закрыть модальное окно
 */
const hide = () => {
	isActive.value = false;
	application.cancelHandlingToBack();
	emit('closed');
};

const onOverlayClick = () => {
	if (props.closeable) {
		hide();
	}
};

defineExpose({
	isActive,
	open,
	hide
});
</script>

<style lang="scss" scoped>
@keyframes slide-with-opacity {
	0% {
		transform: translateY(-40px);
		opacity: 0;
	}

	100% {
		transform: translateY(0);
		opacity: 1;
	}
}

.ui-modal {
	width: 100%;
	overflow: auto;
	background: #fff;
	border-radius: 1.5rem;
	animation: 0.2s ease-out 0s 1 slide-with-opacity;
	position: relative;

	&-container {
		position: fixed;
		z-index: 1000000;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		padding: calc(1rem + var(--safe-area-top)) 1rem
			calc(1rem + var(--safe-area-bottom));
		background: transparent;
		backdrop-filter: blur(1rem);
	}

	&-overlay {
		position: fixed;
		z-index: -1;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: rgba(15, 15, 17, 0.15);
		backdrop-filter: blur(9px);
	}

	&-close-btn {
		position: absolute;
		right: 0.75rem;
		top: 0.75rem;
	}
}
</style>
